export const PHONE_NUMBER_ITALY = /^(\+39)(\s?)(0\d{1,2}|3\d{2})(\s?)(\d{4,8})$/
